export const LOADING_CUSTOMFIELDS = "LOADING_CUSTOMFIELDS";
export const GET_CUSTOMFIELD_LIST = "GET_CUSTOMFIELD_LIST";
export const REMOVE_CUSTOMFIELD = "REMOVE_CUSTOMFIELD";
export const UPSERT_CUSTOMFIELD = "UPSERT_CUSTOMFIELD";